import { NgModule } from '@angular/core';
import { ApxButtonComponent } from './button.component';

@NgModule({
    imports: [ApxButtonComponent],
    exports: [ApxButtonComponent]
})
export class ApxButtonModule {}

// Re-export component for barrel exports
export { ApxButtonComponent } from './button.component';
